import * as types from "./mutation-types";

export default {
  [types.SET_EDITEDQUEUE](state, payload) {
    state.editedQueue = payload;
  },
};
